import { render, staticRenderFns } from "./TestApp.vue?vue&type=template&id=e93b447e&scoped=true&"
import script from "./TestApp.vue?vue&type=script&lang=js&"
export * from "./TestApp.vue?vue&type=script&lang=js&"
import style0 from "./TestApp.vue?vue&type=style&index=0&id=e93b447e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b447e",
  null
  
)

export default component.exports